import React, { useContext } from 'react';

import { GlobalContext } from "../../state/GlobalContext";
import Wrapper from '../structure/Wrapper';
import Quote from '../simple/Quote';

/**
 * Returns the subtitle in a <p> tag if available
 * 
 * @param {string} subtitle 
 * @returns 
 */
function Subtitle({ subtitle }) {

    if( subtitle !== undefined && subtitle !== '' ) {
        return <p className="text-base leading-normal">{subtitle}</p>
    }

    return '';
}

export default function Hero({ title, subtitle, showQuote }) {

    const { quoteItems } = useContext(GlobalContext);
    const quoteItemsCount = quoteItems.standard.length + quoteItems.custom.length;

    return (
        <section>
            <Wrapper className="relative py-8">
                <div className="relative z-30 md:grid md:grid-cols-banner md:items-start md:gap-5">
                    <div>
                        <h1 className="mb-3 font-bold text-secondary text-2xl sm:text-4xl leading-tight md:mb-4">{title}</h1>
                        <Subtitle subtitle={subtitle} />
                    </div>
                    <Quote showQuote={showQuote} count={quoteItemsCount} className="inline-block lg:hidden" />
                </div>
            </Wrapper>
        </section>
    );
}